import { DefaultButton, ICommandBarItemProps, IContextualMenuItem, setVirtualParent, TooltipHost } from "@fluentui/react";
import { useId, useState } from "react";
import { IFile, IFileV2 } from "../../interfaces/base/IBase";
import { IconHelper } from "./iconHelper";


//setFileDetail: React.Dispatch<React.SetStateAction<IFile>>
//------ Para cargar archivo
const onClickLeftCargar = (setFileDetail: React.Dispatch<React.SetStateAction<IFileV2>>, arrayTipoArchivo: string[], text: string) => {

    const _items: ICommandBarItemProps[] = [
        {
            ...IconHelper.ICON_UPLOAD,
            text: `${text}`,
            preferMenuTargetAsEventTarget: true,
            onClick: (
                ev?:
                    | React.MouseEvent<HTMLElement, MouseEvent>
                    | React.KeyboardEvent<HTMLElement>
                    | undefined
            ) => {
                ev?.persist();
                Promise.resolve().then(() => {
                    const inputElement = document.createElement("input");
                    inputElement.style.visibility = "hidden";
                    inputElement.setAttribute("type", "file");

                    arrayTipoArchivo.forEach(element => {

                        inputElement.setAttribute("accept", `.${element}`);
                    });


                    inputElement.onchange = function (ev) {
                        let { files } = ev.target as HTMLInputElement;

                        if (files != undefined) {
                            const file: File = files[0];

                            let nomExtension = file.name.split(".").pop();
                            // let nombre_extension = nomExtension;

                            var formData = new FormData();
                            formData.append("file", file, file.name);

                            //convertimos archivo base64
                            fileToBase64(file, (err: any, result: any) => {

                                if (result) {
                                    // console.log("======== detallle archivo ============")
                                    // console.log(result)
                                    console.log(nomExtension);

                                    setFileDetail({
                                        nombre: file.name,
                                        tamanio: file.size,
                                        tipo: file.type,
                                        archivo: result,
                                        extension: `.${nomExtension}`,

                                    });

                                }
                            });
                        }
                    };

                    document.body.appendChild(inputElement);

                    const target = ev?.target as HTMLElement | undefined;

                    if (target) {
                        setVirtualParent(inputElement, target);
                    }

                    inputElement.click();

                    if (target) {
                        setVirtualParent(inputElement, null);
                    }

                    setTimeout(() => {
                        inputElement.remove();
                    }, 10000);
                });
            },
        },
    ];

    return _items
};

const onClickRigthCargar = () => {
    const _items: ICommandBarItemProps[] = [
        {
            ...IconHelper.ICON_Folder,
            preferMenuTargetAsEventTarget: true,
            onClick: undefined,
        },
    ];

    return _items;
};

const buttonStyles = {
    root: {
        background: "transparent",
        border: "none",
        minWidth: "16px",
        padding: 0,
    },
};

export const iconWithTooltip = (showTooltip: boolean, tooltipId: string, setShowTooltip: React.Dispatch<React.SetStateAction<boolean>>, text: string) => {

    return (
        <>
            <TooltipHost
                content={showTooltip ? text : undefined}
                id={tooltipId}
            >
                <DefaultButton
                    aria-label={"more info"}
                    aria-describedby={showTooltip ? tooltipId : undefined}
                    onClick={() => setShowTooltip(!showTooltip)}
                    styles={buttonStyles}
                    iconProps={{ iconName: "Info" }}
                />
            </TooltipHost>
        </>
    )
};

//convertimos archivo base64
const fileToBase64 = (file: any, cb: any) => {
    const myReader: FileReader = new FileReader();

    myReader.readAsDataURL(file);
    myReader.onloadend = function () {
        cb(null, myReader.result);
    };

    myReader.onerror = function (error) {
        cb(error, null);
    };
};

//abrir archivo otra pestaña
const openInNewTab = (url: string): void => {
    const newWindow = window.open(url, "_blank", "noopener,noreferrer");
    if (newWindow) newWindow.opener = null;
};


//---- para descargar archivo
const onClickLeftDescargar = (setFileDetail: React.Dispatch<React.SetStateAction<any>>, data: Blob, text: string) => {

    const _items: ICommandBarItemProps[] = [
        {
            ...IconHelper.ICON_DOWNLOAD,
            text: `${text}`,
            preferMenuTargetAsEventTarget: true,
            onClick: (
                ev?:
                    | React.MouseEvent<HTMLElement, MouseEvent>
                    | React.KeyboardEvent<HTMLElement>
                    | undefined
            ) => {

                ev?.persist()

                /*  const inputElement = document.createElement("input");
                                    inputElement.style.visibility = "hidden";
                                    inputElement.setAttribute("type", "file");
                                    inputElement.setAttribute("accept", `PNG`); */


                console.log("************* blob data *************")
                console.log(data);

                const url = window.URL.createObjectURL(new Blob([data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'ReporteConsumo.xlsx');
                document.body.appendChild(link);

                /*  inputElement.onchange = function (ev) {

                     let { files } = ev.target as HTMLInputElement;

                     console.log("************* even boton *************")
                     console.log(ev)

                 }; */

                const target = ev?.target as HTMLElement | undefined;

                link.click()

                setTimeout(() => {
                    link.remove();
                }, 10000);

            },
        },
    ];

    return _items
};

const onClickRigthDescargar = () => {
    const _items: ICommandBarItemProps[] = [
        {
            ...IconHelper.ICON_EXCEL,
            preferMenuTargetAsEventTarget: true,
            onClick: undefined,
            text: ""
        },
    ];

    return _items;
};


export {
    onClickLeftCargar,
    onClickRigthCargar,
    openInNewTab,
    onClickLeftDescargar,
    onClickRigthDescargar,
    fileToBase64
}
